import { PAGE_TYPES } from '../../../enums/page-types';
import { formatPrice } from '../../../services/formatPrice';
import checkIsFreeCheckout from '../../../lib/checkIsFreeCheckout';
import hasStock from '../../../lib/hasStock';

export default function getPayButtonText({
  page,
  product,
  subtotalAmount,
  totalDueAmount,
  formVariants,
}) {
  if (page.type === PAGE_TYPES.FORM) {
    return page.submitButtonText;
  }

  if (page.type === PAGE_TYPES.CHECKOUT) {
    if (!hasStock(product)) {
      return page.soldOutButtonText;
    }

    if (product.type === 'subscription') {
      return page.subscribeButtonText;
    }

    const isFreeCheckout = checkIsFreeCheckout({
      amount: totalDueAmount,
      productType: product.type,
      productVariants: product.variants,
      formVariants: formVariants,
    });

    if (isFreeCheckout && subtotalAmount <= 0 && totalDueAmount <= 0) {
      return page.submitButtonText;
    }

    if (page.showPriceOnButton === false) {
      return page.payButtonText;
    }

    return `${page.payButtonText} ${formatPrice({
      amount: totalDueAmount,
      currency: product.currency,
      locale: page.locale,
      style: 'currency',
    })}`;
  }

  if (page.type === PAGE_TYPES.EVENT) {
    if (page.eventDetails?.status === 'canceled') {
      return page.canceledButtonText;
    }

    if (page.eventDetails?.isSoldOut) {
      return page.soldOutButtonText;
    }

    if (page.showPriceOnButton === false) {
      return page.getTicketsButtonText;
    }

    return `${page.getTicketsButtonText} ${formatPrice({
      amount: totalDueAmount,
      currency: page.eventDetails?.currency,
      locale: page.locale,
      style: 'currency',
    })}`;
  }

  return page.payButtonText;
}
